import { render, staticRenderFns } from "./login-phone.vue?vue&type=template&id=1c231356&scoped=true&"
import script from "./login-phone.vue?vue&type=script&lang=js&"
export * from "./login-phone.vue?vue&type=script&lang=js&"
import style0 from "./login-phone.vue?vue&type=style&index=0&id=1c231356&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c231356",
  null
  
)

export default component.exports